var Backbone = require('backbone');
var _ = require('lodash');
var countdown = require('countdown');

('use strict');

module.exports = Backbone.Model.extend({
    defaults: function() {
        return {
            name: 'generic timer',
            countdown_status: 0,
            future_time: null,
            timer: null,
            time_string: null,
            time_months: null,
            time_days: null,
            time_hours: null,
            time_minutes: null,
            time_seconds: null,
            blast_off: null,
            //Should we add these attributes to the Countdown model or add it to the CMS model?
            localTime: null,
            startTime: null,
            countdownStatus: null
        };
    },
    /**
     *
     */
    initialize: function(attributes, options) {
        this.cms = options.cms;

        //Set local time now as it is a dependency for building the future time
        this.set({
            localTime: new Date().getTime()
        });

        //Build remaining dependencies for countdown widget
        this.setData();

        this.listenTo(
            this,
            'change:blast_off',
            _.bind(this.stopInterval, this)
        );

        var cmsCountdown = this.cms.get('text').countdown_clock;

        var units = 0;
        var count = 0;

        if (this.get('countdown_status') <= 0) {
            this.focusChange();
        } else {
            if (parseInt(cmsCountdown.countdown_units.show_month))
                (units |= countdown.MONTHS), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_days))
                (units |= countdown.DAYS), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_hours))
                (units |= countdown.HOURS), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_minutes))
                (units |= countdown.MINUTES), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_seconds))
                (units |= countdown.SECONDS), (count += 1);
        }

        this.initializer = countdown(
            this.get('future_time'),
            _.bind(this.timerInterval, this),
            units,
            count,
            0
        );

        //Changed so that it will check if countdown is already completed
        this.focusChange();
        //$(window).bind("focus", _.bind(this.focusChange, this));
    },
    /**
     *
     */
    setData: function() {
        var countdown = this.cms.get('text').countdown_clock;
        //create format for when countdown ends from CMS
        var date_and_time_str = '';
        if (isNaN(countdown.date_and_time.month_name)) {
            date_and_time_str =
                countdown.date_and_time.month_name +
                ' ' +
                countdown.date_and_time.day_number +
                ' ' +
                countdown.date_and_time.year_number +
                ' ' +
                countdown.date_and_time.hours_number +
                ':' +
                countdown.date_and_time.minutes_number +
                ':' +
                countdown.date_and_time.seconds_number +
                ' ' +
                countdown.date_and_time.AM_or_PM +
                ' ' +
                countdown.date_and_time.timezone;
        } else {
            date_and_time_str =
                countdown.date_and_time.year_number +
                '-' +
                countdown.date_and_time.month_name +
                '-' +
                countdown.date_and_time.day_number +
                ' ' +
                countdown.date_and_time.hours_number +
                ':' +
                countdown.date_and_time.minutes_number +
                ':' +
                countdown.date_and_time.seconds_number +
                ' ' +
                countdown.date_and_time.AM_or_PM +
                ' ' +
                countdown.date_and_time.timezone;
        }

        var startTime = new Date(date_and_time_str).getTime();

        this.set({
            future_time: this.getCountdownTime(startTime),
            countdown_status: startTime > this.cms.get('ts') ? 1 : 0,
            startTime: startTime,
            countdownStatus: startTime > this.cms.get('ts') ? 1 : 0
        });
        //if countdown is already expired
        if (this.get('countdownStatus') === 0) {
            this.set({
                time_months: 0,
                time_days: 0,
                time_hours: 0,
                time_minutes: 0,
                time_seconds: 0,
                time_string: 0,
                blast_off: true
            });
        }
    },
    /**
     *
     */
    timerInterval: function(ts) {
        const timer = ts;
        const timeMonths = timer.months ? timer.months : 0;
        const timeDays = timer.days ? timer.days : 0;
        const timeHours = timer.hours ? timer.hours : 0;
        const timeMinutes = timer.minutes ? timer.minutes : 0;
        const timeSeconds = timer.seconds ? timer.seconds : 0;
        const timeString =
            timeMonths + timeDays + timeHours + timeMinutes + timeSeconds;
        const blastOff =
            timeMonths === 0 &&
            timeDays === 0 &&
            timeHours === 0 &&
            timeMinutes === 0 &&
            timeSeconds === 0
                ? true
                : false;

        this.set({
            timer: timer,
            time_months: timeMonths,
            time_days: timeDays,
            time_hours: timeHours,
            time_minutes: timeMinutes,
            time_seconds: timeSeconds,
            time_string: timeString,
            blast_off: blastOff
        });
    },
    /**
     *
     */
    stopInterval: function(model, value) {
        if (value === true) {
            window.clearInterval(this.initializer);
            this.stopListening();
        }
    },
    /**
     *
     */
    focusChange: function() {
        if (this.getServerTime() > this.get('future_time')) {
            this.set({
                time_months: 0,
                time_days: 0,
                time_hours: 0,
                time_minutes: 0,
                time_seconds: 0,
                time_string: 0,
                blast_off: true
            });
        }
    },
    /**
     * sets our polling timer
     */
    getElapsedTime: function() {
        return new Date().getTime() - this.get('localTime');
    },
    /**
     * @returns unix timestamp in ms
     * @param time - unix timestamp which should always be greater than (in the future of) the server time
     */
    getCountdownTime: function(time) {
        // ms difference between the server time and the future sunrise/sunset time
        var difference = time - this.getServerTime();
        // use local time plus the difference
        return new Date(new Date().getTime() + difference).getTime();
    },
    /**
     *
     */
    getServerTime: function() {
        return this.cms.get('ts') + this.getElapsedTime();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/models/countdown.js
// module id = 276
// module chunks = 0